import { render, staticRenderFns } from "./ServiceRequestDetail.vue?vue&type=template&id=5f63f055&"
import script from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports